export default "__VITE_ASSET__z$BL5XWC__"